module.exports = __webpack_public_path__ + "img/empty-flow.28d9b611.png";